import React, { useEffect } from 'react';

const CoachName = ({ coachName }) => {

  useEffect(() => {
    console.log("coachName", coachName);
  }, []);

  return (
    <div className="inline-flex items-center gap-1.5 md:gap-2 px-2.5 md:px-4 py-1.5 md:py-2 bg-white border-2 border-emerald-300 rounded-xl shadow-md flex-shrink-0">
      {/* Coach Icon */}
      <svg
        className="w-4 h-4 md:w-5 md:h-5 text-[#247E45]"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
        />
      </svg>

      {/* Coach Label and Name */}
      <div className="flex items-center gap-1 md:gap-1.5 whitespace-nowrap">
        <span className="text-xs md:text-sm font-semibold text-[#247E45] hidden sm:inline">Coach:</span>
        <span className="text-xs md:text-sm font-medium text-slate-700">
          {coachName?.firstName} {coachName?.lastName}
        </span>
      </div>
    </div>
  );
};

export default CoachName;
